/**
 * API origin for Capacitor / separate hosts.
 * Browser CRA: leave unset (uses relative `/api` + proxy in `package.json`).
 * Capacitor local: set at build time, e.g. REACT_APP_API_URL=http://10.x.x.x:5000
 */
const RAW_BASE = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');

export const API_BASE = RAW_BASE;
export const API_PREFIX = '/api';

/**
 * Absolute origin for API + `/uploads` assets (empty in normal CRA browser mode).
 */
export function apiOrigin() {
  return API_BASE;
}

/**
 * @param {string} path - e.g. `/sos/active` or `sos/active` (becomes `/api/sos/active`)
 */
export function apiUrl(path) {
  const p = path.startsWith('/') ? path : `/${path}`;
  const apiPath = p.startsWith('/api') ? p : `${API_PREFIX}${p}`;
  if (!API_BASE) return apiPath;
  return `${API_BASE}${apiPath}`;
}

/**
 * Resolve `/uploads/...` against the API host when Capacitor (or split deploy) is used.
 */
export function assetUrl(path) {
  if (!path) return '';
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  const normalized = path.startsWith('/') ? path : `/${path}`;
  if (API_BASE) return `${API_BASE}${normalized}`;
  if (typeof window !== 'undefined') return `${window.location.origin}${normalized}`;
  return normalized;
}
